import { defaultAppConfig, AppConfig } from './types/config.types';

let isConfigLoaded = false;

export const loadConfig = async (): Promise<void> => {
  if (isConfigLoaded) {
    // No need to re-fetch the config if already loaded.
    return;
  }

  try {
    const configPath = '/config.json';
    const resp = await fetch(configPath);
    if (!resp.ok) {
      throw new Error(`Failed to load ${configPath}`);
    }
    const customConfig = await resp.json();

    Object.assign(config, {
      server: customConfig.server || 'http://127.0.0.1:3000',
      connectionErrorTimeout: stringToNumber(customConfig.connectionErrorTimeout, 10000),
      useTurnServer: false,
      turnServer: '',
      turnUser: '',
      turnCredential: '',
      testMode: false,
      showSignerPrompt: false,
      showGloss: false,
      pendoApiKey: customConfig.pendoApiKey || '',
      pendoConversationFeedbackGuideId: customConfig.pendoConversationFeedbackGuideId || '',
    });
    isConfigLoaded = true;
  } catch (err) {
    console.error('Error loading configuration: ', err);
  }
};

const stringToNumber = (value: string | number | undefined, defaultValue: number): number => {
  if (typeof value === 'number') {
    return value;
  }
  if (typeof value !== 'string') {
    return defaultValue;
  }
  const convertedNum = Number.parseInt(value);
  if (Number.isNaN(convertedNum)) {
    return defaultValue;
  }
  return convertedNum;
};

export const config: AppConfig = { ...defaultAppConfig };
